import { cn } from '@/lib/utils';

import Card from '@/components/atoms/Card';
import ImageStrapi from '@/components/atoms/Image/ImageStrapi';

import { Testimonial } from '../Testimonials';

type Props = {
  testimonial: Testimonial;
  isSelected: boolean;
  handleClick: () => void;
};

const CompanyCard = ({ testimonial, isSelected, handleClick }: Props) => {
  return (
    <Card
      roudnessLevel='s'
      hasHoverEffect
      classNames={{
        root: cn(
          'hover:bg-base-white bg-base-white active:bg-base-white',
          'flex-1 flex items-center justify-center cursor-pointer',
          isSelected
            ? 'border-brand-500 border-2 bg-brand-50'
            : 'border-gray-300 border-2'
        ),
      }}
      onClick={handleClick}
      aria-label={`Select ${testimonial.companyName} testimonial`}
    >
      <ImageStrapi
        block={testimonial.logo}
        inner={{
          classNames: {
            container: 'h-full w-full flex items-center justify-center h-5 ',
            image: cn(!isSelected ? 'opacity-50' : 'opacity-100', 'max-h-5'),
          },
        }}
        width={128}
        height={20}
      />
    </Card>
  );
};

export default CompanyCard;
